import { Box, Typography, Tooltip } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useContext, useEffect, useState } from "react"
import OneButton from "../../../../../Components/OneButton/OneButton"
import OneDivider from "../../../../../Components/OneDivider/OneDivider"
import OneTextArea from "../../../../../Components/OneTextArea/OneTextArea"
import { containerNovaEntrega, sessionDocument, sessionFotos, styleBoxImage, sxLinhas } from "./sxNovaEntrega"
import { WebSocketContext } from "../../../../../Providers/WebSocket/WebSocketContext"
import { CondominiosContext } from "../../../../../Providers/CondominiosContext/CondominiosContext"
import { ListaImovelDestinatario } from "../EntregaMultipla/EntregaMultipla"
import WebCam from "../../../../../Components/Webcam/Webcam"
import { Add, Check, HighlightOff, PhotoCamera, Search } from "@mui/icons-material"
import OneInput from "../../../../../Components/OneInput/OneInput"
import { showNotify } from "../../../../../Utils/Utils"
import { UserContext } from "../../../../../Providers/UserContext/UserContex"
import { EncomendaContex } from "../../../../../Providers/EncomendaContext/EncomendaContext"
import ListaItensOrigem from "../ListaItensOrigem/ListaItensOrigem"

const defaultFormData = {
    codigo_rastreio: '',
    observacao_recebedor: '',
    observacao: '',
    id_encomenda_tipo: null,
    id_encomenda_origem: null,
    id_imovel: null,
    cd_acesso: null
}

const NovaEntrega = ({ isModalOpen, setOpenModalNovaEntrega, idToEdit = false }) => {
    const { sendWs, addRoute } = useContext(WebSocketContext)
    const { activeCond } = useContext(CondominiosContext)
    const { user } = useContext(UserContext)
    const { procurarEncomenda } = useContext(EncomendaContex)

    const [formData, setFormData] = useState(defaultFormData)
    const [imoveis, setImoveis] = useState([])
    const [imoveisSelecionado, setImoveisSelecionado] = useState([])
    const [modalCam, setModalCam] = useState(false)
    const [webcamImages, setWebcamImages] = useState([])
    const [documentPreviews, setDocumentPreviews] = useState([])
    const [selectedValueTipo, setSelectedValueTipo] = useState(null)
    const [selectedOrigin, setSelectedOrigin] = useState(null)
    const [resetMorador, setResetMorador] = useState(false)
    const [resetImovel, setResetImovel] = useState(false)
    const [initialData, setInitialData] = useState(null)
    const [enableButton, setEnableButton] = useState(false)
    const [edit, setEdit] = useState(false)
    let adicionarMais = false

    const getImovel = (msg) => {
        let imoveis = msg.data.imoveis.dados

        if (msg.data.status && Array.isArray(imoveis)) {
            let novoImovel = []
            imoveis.map((imovel) => {
                let objeto = {
                    id: imovel.id,
                    descricao: imovel.unidade1 + ' - ' + imovel.unidade2
                }
                novoImovel.push(objeto)
            })
            setImoveis(novoImovel)
        } else {
            showNotify('warning', 'nenhum imóvel encontrado neste condominio')
        }
    }

    const BuscarEncomendasById = (msg) => {
        if (msg.data.status !== 'error') {
            let encomenda = msg.data.encomenda[0]
            const newFormData = {}

            setInitialData(encomenda)

            if (encomenda.observacao_recebedor !== null) {
                newFormData.observacao_recebedor = encomenda.observacao_recebedor
            }
            if (encomenda.codigo_rastreio !== null) {
                newFormData.codigo_rastreio = encomenda.codigo_rastreio
            }
            if (encomenda.observacao !== null) {
                newFormData.observacao = encomenda.observacao
            }

            setFormData(newFormData)

            if (encomenda.id_tipo) {
                setSelectedValueTipo(encomenda.id_tipo)
            }

            if (encomenda.id_imovel) {
                setImoveisSelecionado([{ id_imovel: encomenda.id_imovel }])
            }
            if (encomenda.id_origem) {
                setSelectedOrigin(encomenda.id_origem)
            }

            if (encomenda.possui_anexos == 1) {
                let stringBase64 = []

                if (encomenda.anexos && encomenda.anexos.length > 0) {
                    encomenda.anexos.map((item) => {
                        if ((item.extensao == 'jpeg' || item.extensao == 'png' || item.extensao == 'jpg') && item.base64) {
                            stringBase64.push(`data:image/${item.extensao};base64,${item.base64}`)
                        }
                    })
                    setWebcamImages(stringBase64)
                }
            }
            setEdit(true)
        } else {
            showNotify('error', 'Algo deu errado ao tentar buscar a encomenda')
        }
    }

    // useEffect(() => {
    //     if (idToEdit) {
    //         sendWs("BuscarEncomendasById", { id: idToEdit })
    //         addRoute("BuscarEncomendasById", BuscarEncomendasById)
    //     } else {
    //         setEdit(true)
    //     }

    //     if (imoveis.length == 0 && activeCond && activeCond.id_central) {
    //         sendWs("getImovel", { id_central: activeCond.id_central })
    //         addRoute("getImovel", getImovel)
    //     }
    //     if (isModalOpen) {
    //         handleEnableButton()
    //     }
    // }, [isModalOpen, imoveisSelecionado, selectedValueTipo, selectedOrigin])

    useEffect(() => {
        if (!isModalOpen) return

        if (idToEdit) {
            sendWs("BuscarEncomendasById", { id: idToEdit })
            addRoute("BuscarEncomendasById", BuscarEncomendasById)
        } else {
            setFormData({})
            setSelectedValueTipo(null)
            setSelectedOrigin(null)
            setImoveisSelecionado([])
            setWebcamImages([])
            setInitialData(null)
            setEdit(true)
        }
        if (imoveis.length === 0 && activeCond?.id_central) {
            sendWs("getImovel", { id_central: activeCond.id_central })
            addRoute("getImovel", getImovel)
        }
    }, [isModalOpen])

    useEffect(() => {
        handleEnableButton()
    }, [formData, imoveisSelecionado, selectedValueTipo, selectedOrigin])

    const handleChangeInput = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
        setTimeout(() => console.log(formData), 60000)
    }

    const handleTipo = (event) => {
        setFormData({ ...formData, id_encomenda_tipo: event.currentTarget.value })
        setSelectedValueTipo(event.currentTarget.value)
    }

    const handleChangeImoveis = (e) => {
        if (e.target.name === 'imovel') {
            let newImoveis = e.target.value

            if (newImoveis !== formData?.id_imovel) {
                if (newImoveis === 0 || newImoveis === '') {
                    setImoveisSelecionado([])
                    setFormData({ ...formData, id_imovel: newImoveis, cd_acesso: '' })
                    setResetMorador(true)
                } else {
                    setImoveisSelecionado([{ id_imovel: newImoveis }])
                    setFormData({ ...formData, id_imovel: newImoveis, cd_acesso: '' })
                    setResetMorador(true)
                }
            }
        }
    }

    const handleChangeMoradores = (e) => {
        let cd_acesso = e.target.cd_acesso
        let index = e.target.index

        if (index != undefined && cd_acesso != undefined) {
            setFormData({ ...formData, cd_acesso })
        }
    }

    const handleCapFotoWebCam = () => {
        setModalCam(true)
    }

    const fotoWebCam = (base64img) => {
        const updatedImages = [...webcamImages, base64img]
        setWebcamImages(updatedImages)
        setFormData(prev => ({
            ...prev,
            fotos: updatedImages
        }))
    }

    const handleRemoveImage = (index) => {
        const updatedImages = webcamImages.filter((_, i) => i !== index)
        setWebcamImages(updatedImages)
        setFormData(prev => ({
            ...prev,
            fotos: updatedImages
        }))
    }

    const handleFileChangeSubirFoto = (e) => {
        const file = e.target.files[0]
        if (file) {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {
                const base64 = reader.result
                const updatedImages = [...webcamImages, base64]
                setFormData(prev => ({
                    ...prev,
                    fotos: updatedImages
                }))
                setWebcamImages(updatedImages)
            }
        }
    }
    const handleSubirFoto = () => {
        const fileInput = document.createElement('input')
        fileInput.type = 'file'
        fileInput.accept = 'image/*'
        fileInput.onchange = handleFileChangeSubirFoto
        fileInput.click()
    }

    // const handleFileChangeDocument = (e) => {
    //     const file = e.target.files[0]
    //     if (file) {
    //         const reader = new FileReader()
    //         reader.readAsDataURL(file)
    //         reader.onload = () => {
    //             const base64 = reader.result
    //             let obj = {
    //                 name: file.name,
    //                 data: base64
    //             }

    //             setFormData(prev => ({ ...prev, documentos: [obj] }))

    //             setDocumentPreviews(prevPreviews => [
    //                 ...prevPreviews,
    //                 { name: file.name, data: base64, url: URL.createObjectURL(file) }
    //             ])
    //         }
    //     }
    // }

    // const handleProcurarArquivo = () => {
    //     const fileInput = document.createElement('input')
    //     fileInput.type = 'file'
    //     fileInput.accept = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf'
    //     fileInput.onchange = handleFileChangeDocument
    //     fileInput.click()
    // }

    const getEditarEncomenda = (msg) => {
        let response = msg.data.status

        if (response !== 'error') {
            if (adicionarMais) {
                showNotify('success', 'Entrega Cadastrada com sucesso!')

                setFormData(null)
                setInitialData(null)
                setSelectedOrigin(null)
                setSelectedValueTipo(null)
                setDocumentPreviews([])
                setWebcamImages([])
                setImoveisSelecionado([])
                setResetMorador(true)
                setResetImovel(true)
                adicionarMais = false
            } else {
                procurarEncomenda()
                showNotify('success', 'Encomenda editada com sucesso')
            }
        } else {
            showNotify('error', 'Algo deu errado ao tentar editar a encomenda')
        }
    }

    const handleEnableButton = () => {
        if (!formData) return setEnableButton(true)
        // Verificar se existe imóvel ou destinatário
        const hasRealtyOrDestination = imoveisSelecionado.length > 0 || formData?.cd_acesso > 0
        // Se existe imóvel ou destinatário, `selectedValueTipo` e `selectedOrigin` precisam ser verdadeiros
        const hasTypeAndOrigin = selectedValueTipo && selectedOrigin
        // A lógica final depende de `hasRealtyOrDestination`
        const lock = hasRealtyOrDestination ? hasTypeAndOrigin : false

        setEnableButton(!lock)
    }

    const handleSubimit = (e) => {
        if (!formData) {
            showNotify("warning", "Nenhuma alteração feita!")
            return
        }

        let data = formData

        if (initialData?.id_encomenda != null && idToEdit) {
            data.id_encomenda = idToEdit
            data.user_id = user.id
            data.id_central = activeCond.id_central

            if (formData?.documentos || formData?.fotos) {
                data.possui_anexos = 1
            } else {
                data.possui_anexos = 0
            }
            sendWs("EditarEncomenda", data)
            addRoute("EditarEncomenda", getEditarEncomenda)
        } else {
            data.encomenda_futura = 0
            data.id_central = activeCond.id_central
            data.status = 0

            if (formData?.documentos || formData?.fotos) {
                data.possui_anexos = 1
                data.user_id = user.id
            } else {
                data.possui_anexos = 0
            }

            if (formData?.id_encomenda_tipo == undefined) {
                showNotify("warning", "Precisa preencher o tipo da encomenda!")
                return
            }
            if (formData?.id_encomenda_origem == undefined) {
                showNotify("warning", "Precisa preencher origem da encomenda!")
                return
            }

            if (formData?.id_imovel == undefined && formData?.cd_acesso == undefined) {
                showNotify("warning", "Precisa preencher o imóvel ou nome do morador!")
                return
            }

            sendWs("CriarEncomenda", data)
            addRoute("CriarEncomenda", getCriarEncomenda)
        }
    }

    const getCriarEncomenda = (msg) => {
        if (msg.data.status) {
            if (adicionarMais) {
                showNotify('success', 'Entrega Cadastrada com sucesso!')

                setFormData(null)
                setInitialData(null)
                setSelectedOrigin(null)
                setSelectedValueTipo(null)
                setDocumentPreviews([])
                setWebcamImages([])
                setImoveisSelecionado([])
                setResetMorador(true)
                setResetImovel(true)
                adicionarMais = false
            } else {
                showNotify('success', 'Entrega Cadastrada com sucesso!')
                setOpenModalNovaEntrega(false)
            }

            procurarEncomenda()
        } else {
            showNotify('error', msg.data.error || 'Algo deu errado ao tentar criar a encomenda', 5000)
            setOpenModalNovaEntrega(false)
        }
    }

    const itemsType = [
        { value: 1, name: 'PACOTE' },
        { value: 2, name: 'CAIXA' },
        { value: 3, name: 'ENVELOPE' },
        { value: 4, name: 'DOCUMENTO' },
        { value: 5, name: 'OUTRO' }
    ]

    const handleOpenImage = (base64Image) => {
        const novaJanela = window.open('', '_blank')
        novaJanela.document.write(`
          <html>
            <head>
              <title>Imagem</title>
              <style>
                body { margin: 0; padding: 5px; text-align: center; }
                img { }
              </style>
            </head>
            <body>
              <img src="${base64Image}" alt="Imagem" />
            </body>
          </html>
        `)
        novaJanela.document.close()
    }

    return (
        <Grid xs={12} sm={12} md={12} lg={12} xl={12} sx={containerNovaEntrega}>
            {
                edit &&
                <>
                    <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                        <ListaImovelDestinatario
                            imoveis={imoveis}
                            activeCond={activeCond}
                            handleChangeImoveis={handleChangeImoveis}
                            handleChangeMoradores={handleChangeMoradores}
                            imoveisSelecionado={imoveisSelecionado}
                            resetImovel={resetImovel}
                            resetMorador={resetMorador}
                            newSx={ '80%' }
                            defaultValue={initialData?.morador || ""}
                            defaultValueImovel={initialData?.id_imovel || ""}
                            isDefault={false}
                            isRequired={true}
                            disabled={!imoveisSelecionado.length}
                        />
                    </Grid>

                    <OneDivider />

                    <Grid container xs={12} sm={12} md={12} lg={12} xl={12} sx={{ alignItems: 'center' }}>

                        <Grid xs={1} sm={1.6} md={2} lg={2} xl={2}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <span style={{ fontSize: '13px', fontWeight: '600', color: 'red' }}>*</span>
                                <Typography >Tipo:</Typography>
                            </div>
                        </Grid>
                        <Grid container xs={8} sm={9} md={10} lg={10} xl={10} gap={1.9}>
                            {
                                itemsType.map((item, index) => {
                                    return (
                                        <OneButton
                                            key={index}
                                            id="button_teste"
                                            color="one_primary"
                                            variant="contained"
                                            value={item.value}
                                            onClick={handleTipo}
                                            isColorDefault={false}
                                            newSx={{
                                                border: '1px solid #000000',
                                                minWidth: '90px',
                                                backgroundColor: selectedValueTipo == item.value ? '#9c27b0cc' : 'inherit',
                                                color: selectedValueTipo == item.value ? 'white' : 'inherit',
                                                ":hover": {
                                                    backgroundColor: 'transparent',
                                                    color: '#600385',
                                                    border: "1px solid #600385"
                                                }
                                            }}
                                        >
                                            {item.name}
                                        </OneButton>
                                    )
                                })
                            }
                        </Grid>

                    </Grid>

                    <Grid xs={12} sm={12} md={12} lg={12} xl={12} container gap={2} sx={{ alignItems: 'center' }}>
                        <Grid xs={1.2} sm={1.3} md={1.7} lg={1.7} xl={1.7}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <span style={{ fontSize: '13px', fontWeight: '600', color: 'red' }}>*</span>
                                <Typography sx={{ marginRight: '30px' }}>Origem:</Typography>
                            </div>
                        </Grid>
                        <ListaItensOrigem
                            selectedOrigin={selectedOrigin}
                            setSelectedOrigin={setSelectedOrigin}
                            setFormData={setFormData}
                        />
                    </Grid>

                    <OneDivider />

                    <Grid xs={12} sm={12} md={12} lg={12} xl={12} container sx={{ alignItems: 'center' }}>

                        <Grid xs={4} sm={4} md={4} lg={4} xl={4}>
                            <Typography >Número de registro da encomenda:</Typography>
                        </Grid>
                        <Grid xs={8} sm={8} md={8} lg={8} xl={8}>
                            <OneInput
                                value={formData?.codigo_rastreio || ''}
                                onChange={handleChangeInput}
                                name='codigo_rastreio'
                                newSx={{ height: '30px' }}
                            />
                        </Grid>

                    </Grid>

                    <Grid xs={12} sm={12} md={12} lg={12} xl={12} container>

                        <Grid xs={2} sm={2} md={4} lg={4} xl={4}>
                            <Typography>Observação Recebedor:</Typography>
                        </Grid>

                        <Grid xs={10} sm={10} md={8} lg={8} xl={8} sx={{ height: '80px' }}>
                            <OneTextArea
                                value={formData?.observacao_recebedor || ''}
                                name={'observacao_recebedor'}
                                onChange={handleChangeInput}
                            ></OneTextArea>
                        </Grid>
                    </Grid>

                    {
                        idToEdit &&
                        <Grid xs={12} sm={12} md={12} lg={12} xl={12} container sx={{ alignItems: 'center' }}>

                            <Grid xs={4} sm={4} md={4} lg={4} xl={4}>
                                <Typography >Observação Morador:</Typography>
                            </Grid>

                            <Grid xs={8} sm={8} md={8} lg={8} xl={8}>
                                <OneInput
                                    value={formData?.observacao || ''}
                                    readOnly={true}
                                    name='observacao'
                                    newSx={{ height: '30px' }}
                                />
                            </Grid>

                        </Grid>
                    }

                    <OneDivider />

                    <Grid xs={12} sm={12} md={12} lg={12} xl={12} container sx={{ alignItems: 'center' }}>

                        <Grid xs={2} sm={2} md={2} lg={2} xl={2}>
                            <Typography>Anexos:</Typography>
                        </Grid>

                        <Grid xs={10} sm={10} md={10} lg={10} xl={6} gap={1} container>
                            {/* <OneButton
                            color="one_primary"
                            backgroundColor='true' variant="contained" IconStart={Search} sxIconStart={{ width: '20px' }} onClick={handleProcurarArquivo}>
                                PROCURAR ARQUIVO
                        </OneButton> */}

                            <OneButton
                                newSx={{ border: '0px' }}
                                color="one_secondary_light"
                                backgroundColor='true' variant="contained" onClick={() => { handleSubirFoto() }} IconStart={Search} sxIconStart={{ width: '20px' }}>
                                PROCURAR IMAGEM
                            </OneButton>

                            <OneButton
                                newSx={{ border: '0px' }}
                                color="one_secondary_light"
                                backgroundColor='true' variant="contained" onClick={() => { handleCapFotoWebCam() }} IconStart={PhotoCamera} sxIconStart={{ width: '20px' }}>
                                WEBCAM
                            </OneButton>

                        </Grid>
                    </Grid>
                    {
                        documentPreviews.length > 0 &&
                        <Box sx={{ ...sessionDocument, maxHeight: documentPreviews.length > 0 ? '100px' : '' }}>
                            {documentPreviews.map((doc, index) => (
                                <div key={index}>
                                    <a href={doc.url} target="_blank" rel="noopener noreferrer">{doc.name}</a>
                                </div>
                            ))}
                        </Box>
                    }

                    {
                        webcamImages.length > 0 &&
                    <Grid xs={12} sm={12} md={12} lg={12} xl={12} >

                        <Box sx={{ ...sessionFotos, border: webcamImages.length > 0 ? '' : '1px solid white' }}>
                            {
                                webcamImages.map((image, index) => (
                                    <Box key={index} sx={styleBoxImage} onClick={() => handleOpenImage(image)}>

                                        <div style={{
                                            position: 'absolute',
                                            top: 20,
                                            right: 9,
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            alignItems: 'center',
                                            color: 'red',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => handleRemoveImage(index)}><HighlightOff/></div>

                                        <img style={{
                                            width: '202px',
                                            height: '198px',
                                            borderRadius: '8px',
                                            boxShadow: '2px 2px 4px 2px black'
                                        }} src={image} alt={`webcam-${index}`} />
                                    </Box>
                                ))}
                        </Box>
                    </Grid>
                    }

                    <OneDivider sx={{ margin: '10px 0' }} />

                    <Grid xs={12} sm={12} md={12} lg={12} xl={12} sx={ sxLinhas } container gap={2}>

                        <OneButton
                            newSx={{ border: '0px' }}
                            color="one_secondary_light"
                            backgroundColor='true' variant="contained" onClick={(e) => { adicionarMais = true; handleSubimit(e) }} IconStart={Add} sxIconStart={{ width: '20px' }}>
                            ADICIONAR MAIS
                        </OneButton>

                        <Tooltip
                            title={ enableButton
                                ? "É necessário selecionar o TIPO e ORIGEM e a opção IMÓVEL"
                                : ""
                            }
                            arrow
                            placement="top"
                        >
                            <span>
                                <OneButton
                                    disabled={enableButton}
                                    newSx={{ border: '0px' }}
                                    color="one_primary"
                                    backgroundColor='true'
                                    variant="contained"
                                    onClick={(e) => { handleSubimit(e) }} IconStart={Check} sxIconStart={{ width: '20px' }}
                                >
                                    CONCLUIR
                                </OneButton>
                            </span>
                        </Tooltip>

                    </Grid>

                    <WebCam open={modalCam} setOpen={setModalCam} retornoFunc={fotoWebCam} semMask={true}/>
                </>
            }
        </Grid>
    )
}

export default NovaEntrega
